import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: false
};

const invalidEmailSlice = createSlice({
  name: 'invalidEmail',
  initialState,
  reducers: {
    setInvalidEmail: (state, action) => {
      state.value = action.payload;
    }
  }
});


export const { setInvalidEmail } = invalidEmailSlice.actions;


export default invalidEmailSlice.reducer;
